import React from 'react';
import { Box, Flex, Image, Text } from '@opendoor/bricks/core';
import { formatCurrency } from '@opendoor/bricks/helpers/currencyHelpers';
import Tooltip from '../shared/Tooltip';
interface PropertyValueProps {
  estimatedPropertyValue?: number | null;
}

const PropertyValue: React.FC<PropertyValueProps> = ({ estimatedPropertyValue }) => {
  return (
    <Box>
      <Flex alignItems="center">
        <Text as="h2" fontSize="s3" lineHeight="s3" fontWeight="bold" display="inline">
          What it's worth
        </Text>
        <Tooltip analyticsName="cosmos-what-is-mls">
          <Box as="span">
            <Text as="span" mt={1} mb={2}>
              <Text as="span" color="brand50" fontWeight="semibold">
                HIGH
              </Text>{' '}
              <Text as="span" fontWeight="semibold" color="neutrals0">
                CONFIDENCE
              </Text>
            </Text>
            <Text
              as="span"
              padding={[null, null, null, null, '5px']}
              fontSize={['s00', 's0', 's0', 's0', 's0']}
              fontWeight="semibold"
              color="neutrals0"
            >
              Our brokerage based this estimate off a moderate set of comparable homes data and/or
              potentially dated neighborhood information.
            </Text>
          </Box>
        </Tooltip>
      </Flex>
      {estimatedPropertyValue && (
        <Flex mt={[6, 7]} width="100%">
          <Text fontSize="s2" fontWeight="semibold" mr="4">
            {formatCurrency(estimatedPropertyValue / 100)}
          </Text>
          <Flex width="100%" alignItems="center">
            <Image
              mr="2"
              src="https://imgdrop.imgix.net/696df48225044df1a2d74fdd8866a5fc.svg"
              alt="Confidence icon"
            />
            <Text fontWeight="semibold" fontSize="s0">
              High confidence
            </Text>
          </Flex>
        </Flex>
      )}
      <Text color="neutrals90" my={[4, 5]}>
        Interested in learning more about the value of this home? Talk with one of our partner
        agents. It's free and without any obligation.
      </Text>
      {/* TODO: Post-launch fast follow to implement "discuss pricing" feature */}
      {/* <Link
        target="_blank"
        color="brand50"
        fontWeight="semibold"
        aria-label="Go to learn more about what this home is worth"
        analyticsName="cosmos-pdp-property-pricing"
      >
        Discuss pricing
      </Link> */}
    </Box>
  );
};

export default PropertyValue;
